import { render, staticRenderFns } from "./ProductsSelectPublic.vue?vue&type=template&id=48e57293&"
import script from "./ProductsSelectPublic.vue?vue&type=script&lang=js&"
export * from "./ProductsSelectPublic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports